import {
  Route,
  Routes,
  BrowserRouter,
} from "react-router-dom";
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';

import HomePage from './Home';
import About from './About';
import Contact from "./Contact";
import Policy from "./Policy";
import Detailing from "./Detailing";
import Inventory from "./Inventory";
import FAQ from "./FAQ";
import CarDetails from "./CarDetails";
import NotFound from "./NotFound";
import PaymentCalculator from "./PaymentCalculator";
import GetFinancedPage from "./GetFinancedPage";


function App() {

  return (
    <div className="App">
      <BrowserRouter>
        <I18nextProvider i18n={i18n}>
        <Routes>
          <Route path="/" element={<HomePage />}></Route>
          <Route path="/inventory" element={<Inventory />}></Route>
          <Route path="inventory/:id" element={<CarDetails />}></Route>
          <Route path="/about" element={<About />}></Route>
          <Route path="/contact" element={<Contact />}></Route>
          <Route path="/policy" element={<Policy />}></Route>
          <Route path="/detailing" element={<Detailing />}></Route>
          <Route path="/faq" element={<FAQ />}></Route>
          <Route path="/get-financed" element={<GetFinancedPage />}></Route>
          <Route path="/calc" element={<PaymentCalculator />}></Route>
          <Route path="*" element={<NotFound />} />
        </Routes>
        </I18nextProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
